import { $, $$ } from 'utils/dom';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiperslider from 'modules/swiper/swiper';
// import { viewport } from '../getViewport';

export const storyQuotes = () => {
  const quotes = $$('.story-quotes');

  if (quotes.length) {
    quotes.forEach(item => {
      const slider = new Swiperslider($('.story-quotes__slider', item), {
        container: item,
        sliderOptions: {
          slidesPerView: 1,
          scrollbar: false,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: 'true',
          },
        },
      });
      slider.init();
    });
  }
};
